var render = function render(){var _vm=this,_c=_vm._self._c;return _c('masked-input',{class:_vm.maskedInputClass,attrs:{"id":_vm.id,"placeholder":_vm.placeholder,"mask":"(###) ###-#### x#####","type":"tel","disabled":_vm.disabled},nativeOn:{"keyup":function($event){return _vm.keyup.apply(null, arguments)}},model:{value:(_vm.phoneNumber),callback:function ($$v) {_vm.phoneNumber=$$v},expression:"phoneNumber"}})
}
var staticRenderFns = []

export { render, staticRenderFns }